import React, { useEffect, useRef, useState} from 'react'
import styles from './DispatchPage.module.css'
import {
    AppBar,
    Button, Checkbox,
    CircularProgress, debounce,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText, FormControlLabel,
    IconButton
} from '@material-ui/core'
import SignatureCanvas from 'react-signature-canvas'
import TextField from '@mui/material/TextField'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { v4 as uuid } from "uuid";
import Compressor from 'compressorjs';


import {
    Alert,
    CardHeader,
    FormControl,
    Grid,
    ImageList,
    InputLabel,
    MenuItem,
    Select
} from '@mui/material'
import { useParams } from 'react-router'
import {
    SectionData,
    Sections,
    useFetchDispatch,
    useUpdateDispatch,
    useUpdateTempDispatch
} from '../../queries/useDispatch'
import { useForm } from 'react-hook-form'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import cn from 'classnames'
import { Wrapper, Status } from '@googlemaps/react-wrapper'

import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto'
import ClearIcon from '@mui/icons-material/Clear';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Add } from '@mui/icons-material'
import { EquipmentForm } from './EquipmentForm'
import { TimeEntryForm } from './TimeEntryForm'
import Dropzone from "react-dropzone";
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import axios from "axios";
import PdfViewerComponent from "../../components/PdfViewerComponent";
import dayjs from "dayjs";
import LoadingBackdrop from "../../components/common/LoadingBackdrop";
import Snackbar from "@mui/material/Snackbar";
import { DBConfig } from './DBConfig';
import {initDB, useIndexedDB} from 'react-indexed-db-hook';
import {setNetworkState, useNetworkOnline} from "../../slices/authSlice";
// import imageCompression from "browser-image-compression";
import {getConfig} from "../../AppConfig";
import Dexie from 'dexie';
import { db } from './db';

// initDB(DBConfig);

interface Params {
    userGuid: string
}

const DispatchTestPage = () => {
    const { version } = getConfig()
    const [titleMessage, setTitleMessage] = React.useState('...')


    useEffect(() => {
        db.delete().then(() => {
            setTitleMessage("Database successfully deleted");
        }).catch((err) => {
            setTitleMessage("Could not delete database");
        }).finally(() => {
            // Do what should be done next...
        });
    }, [])

    return (
        <>
            <AppBar position="absolute" className={cn(styles.appBar, styles.shift)}>
                <Typography style={{display: 'inline-block'}} variant="h6" color="primary" component="div" align="center">
                    {'Remove DB'}
                    <Typography textAlign="right" fontSize={'11px'} style={{display: 'inline-block', paddingLeft: '2px'}} variant="caption" color="textDisabled" component="div" >
                        {version}
                    </Typography>
                </Typography>
            </AppBar>
            <div className={styles.root}>
                <Container>
                    <Box>
                        <Grid
                            container
                            border={0}
                            direction="row"
                            alignItems="center"
                            height={'100%'}
                            width={'100%'}
                        >
                            {titleMessage}
                        </Grid>
                    </Box>
                </Container>

            </div>
        </>
    )
}

export default DispatchTestPage